import React from "react";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { uploadLicense } from "slices/systemAdmin/actions/license";

const LicenseUpload = () => {
  const dispatch = useDispatch();
  const onOk = (formData) => dispatch(uploadLicense(formData));
  return (
    <div className="license__content__upload">
      <span>
        Upload Additional <br /> License File
      </span>
      <Button
        onClick={() =>
          dispatch(
            showModal(modalTypes.IMPORT_FILE, {
              title: "Upload License",
              accepts: ".lic",
              onOk,
            })
          )
        }
        variant={buttonVariants.primary}
        content="Upload License File"
        title="Upload License File"
      />
    </div>
  );
};

export default LicenseUpload;
